import React, { useState, useEffect, useCallback } from "react";
import PhoneInput from "../../../common/components/PhoneInput";
import { FaWhatsapp, FaTimes } from "react-icons/fa";
import axios from "axios";
import { getUserProfile, updateUserProfile } from "../../services/userAuthService";
import "./MobileNumberPrompt.css";

const DISMISS_KEY = "mobilePromptDismissedAt";
const DISMISS_DURATION_MS = 24 * 60 * 60 * 1000; // 24 hours

const MobileNumberPrompt = () => {
 const [visible, setVisible] = useState(false);
 const [mobileNumber, setMobileNumber] = useState("");
 const [dialCode, setDialCode] = useState("+91");
 const [countryCodes, setCountryCodes] = useState([]);
 const [whatsappConsent, setWhatsappConsent] = useState(false);
 const [error, setError] = useState("");
 const [loading, setLoading] = useState(false);
 const [success, setSuccess] = useState(false);

 useEffect(() => {
 axios.get(`${process.env.REACT_APP_BASE_URL}/public/country-codes`)
 .then(res => setCountryCodes(res.data?.data || []))
 .catch(() => {});
 }, []);

 const checkAndShow = useCallback(async () => {
 // Only for logged-in users
 const token = localStorage.getItem("token");
 if (!token) return;

 // Check 24hr dismiss
 const dismissedAt = localStorage.getItem(DISMISS_KEY);
 if (dismissedAt && Date.now() - parseInt(dismissedAt, 10) < DISMISS_DURATION_MS) return;

 try {
 const res = await getUserProfile();
 const profile = res.data;
 const mobile = profile?.mobileNumber || profile?.mobile_number;
 if (!mobile) {
 setVisible(true);
 }
 } catch (err) {
 // Silently fail — don't block homepage
 }
 }, []);

 useEffect(() => {
 checkAndShow();
 }, [checkAndShow]);

 const handleDismiss = () => {
 localStorage.setItem(DISMISS_KEY, Date.now().toString());
 setVisible(false);
 };

 const handleSave = async () => {
 setError("");

 if (!mobileNumber) {
 setError("Please enter your mobile number");
 return;
 }

 const e164Regex = /^\+[1-9]\d{1,14}$/;
 if (!e164Regex.test(dialCode + mobileNumber)) {
 setError("Please enter a valid mobile number");
 return;
 }

 setLoading(true);
 try {
 await updateUserProfile({
 country_code: dialCode,
 mobile_number: mobileNumber,
 whatsapp_enabled: whatsappConsent,
 });
 setSuccess(true);
 setTimeout(() => setVisible(false), 1500);
 } catch (err) {
 const raw = err.response?.data?.message || "";
 setError(
 raw.includes("INTERNAL_ERROR") || raw.includes("cannot be cast")
 ? "Something went wrong. Please try again later."
 : raw || "Failed to save. Please try again."
 );
 } finally {
 setLoading(false);
 }
 };

 if (!visible) return null;

 return (
 <div className="mobile-prompt-overlay">
 <div className="mobile-prompt-banner">
 <button className="mobile-prompt-close" onClick={handleDismiss} aria-label="Dismiss">
 <FaTimes />
 </button>

 {success ? (
 <div className="mobile-prompt-success">
 <FaWhatsapp style={{ color: "#25D366", fontSize: 20 }} />
 <span>Mobile number saved successfully!</span>
 </div>
 ) : (
 <div>
 <div className="mobile-prompt-header">
 <FaWhatsapp style={{ color: "#25D366", fontSize: 18, flexShrink: 0, marginTop: 1 }} />
 <span>Add your WhatsApp number to get session reminders &amp; updates</span>
 </div>

 <div className="mobile-prompt-body">
 <PhoneInput
 countryCodes={countryCodes}
 dialCode={dialCode}
 onDialCodeChange={setDialCode}
 mobileNumber={mobileNumber}
 onMobileNumberChange={(val) => { setMobileNumber(val); setError(""); }}
 placeholder="WhatsApp number"
 />
 <button
 className="mobile-prompt-save-btn"
 onClick={handleSave}
 disabled={loading}
 >
 {loading ? "Saving..." : "Save"}
 </button>
 </div>

 <label className="mobile-prompt-consent">
 <input
 type="checkbox"
 checked={whatsappConsent}
 onChange={(e) => setWhatsappConsent(e.target.checked)}
 />
 <span>I agree to receive WhatsApp notifications</span>
 </label>

 {error && <p className="mobile-prompt-error">{error}</p>}
 </div>
 )}
 </div>
 </div>
 );
};

export default MobileNumberPrompt;
